<template>
  <div class="row">
   <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <c-card title="안전사고 기본정보" class="cardClassDetailInfo">
        <template slot="card-button">
          <q-btn-group outline >
            <c-btn 
              v-show="editable&&!param.isApprovePop&&!this.standardInfo.sysApprovalRequestId"
              :isSubmit="isDeleteAuth"
              :url="deleteAuthUrl"
              :param="standardInfo"
              mappingType="PUT"
              label="삭제" 
              icon="delete"
              auth="SAFHEA"
              @beforeAction="deleteAuthAccident"
              @btnCallback="deleteAuthCallback" />
            <c-appr-btn 
              v-if="!param.isApprovePop"
              ref="appr-btn"
              name="process-accident-btn"
              :editable="editable"
              :approvalInfo="approvalInfo"
              @beforeApprAction="saveDataAppr"
              @callbackApprAction="approvalCallback"
              @requestAfterAction="getStdInfo"
            />
            <c-btn 
              v-show="completeEditable" 
              :isSubmit="isComplete1"
              :url="completeUrl"
              :param="tabParam"
              :mappingType="completeType"
              label="조사완료" 
              icon="check"
              @beforeAction="completeAccident"
              @btnCallback="completeCallback" />
            <c-update-btn 
              name="updateBtn"
              :data="param.updateBtnProps.data"
              :btnEditable="param.updateBtnProps.btnEditable"
              :flagCondition="param.updateBtnProps.flagCondition"
            />
            <!-- <c-btn 
              v-show="isInvest && !disabled && tabParam.accidentStatusCd === 'ISPC000002'" 
              :isSubmit="isComplete2"
              :url="completeUrl"
              :param="tabParam"
              :mappingType="completeType"
              label="종결처리" 
              icon="check"
              @beforeAction="completeAccident('END')"
              @btnCallback="completeCallback" /> -->
            <!-- <c-btn v-if="!disabled" label="삭제" :editable="editable" icon="delete_forever" @btnClicked="remove" /> -->
          </q-btn-group>
        </template>
        <template slot="card-detail">
          <div class="col-3">
            <c-label-text title="사고번호" :value="standardInfo.accidentNo"></c-label-text>
          </div>
          <div class="col-3">
            <c-label-text title="사고명" :value="standardInfo.accidentName"></c-label-text>
          </div>
          <div class="col-3">
            <c-label-text title="재해일시" :value="standardInfo.occurrenceDate"></c-label-text>
          </div>
          <div class="col-3">
            <c-label-text title="발생원인" :value="standardInfo.occurrenceModeLargeName"></c-label-text>
          </div>
        </template>
      </c-card>
    </div> 
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <c-tab
        type="vertical"
        :tabItems="tabItems"
        :height.sync="tabHeight"
        v-model="tab"
      >
        <template v-slot:default="tab">
          <component
            :is="tab.component"
            :key="tab.key"
            :popupParam="param"
            :tabParam="tabParam"
            :standardInfo="standardInfo"
            @transInfo="transInfo"
            @currentStep="currentStep"
            @isInvestY="isInvestY"
          />
        </template>
      </c-tab>
    </div>
  </div>
</template>

<script>
import { uid } from 'quasar'
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'process-accident-reception',
  props: {
    param: {
      type: Object,
      default: () => ({
        iimAccidentId: '',
        stepCd: '',
        count: 0,
        isApprovePop: false,
        updateBtnProps: {
          data: {
            title: '사고',
            flag: false,
          },
          flagCondition: false,
          btnEditable: false
        }
      }),
    },
    height: {
      type: String,
      default: function() {
        return '';
      },
    },
    isApprovePop: {
      type: Boolean,
      default: function() {
        return false;
      },
    },
  },
  data() {
    return {
      editable: true,
      standardInfo: {
        accidentNo: '',
        accidentName: '',
        accidentKindName: '',
        accidentGradeName: '',
        occurrenceDate: '',
        occurrenceDeptName: '',
        occurrenceModeLargeName: '',
        occurrenceModeSmallName: '',
        accidentStatusCd: '',
        approvalStatusCd: '', // 결재관련 결재상태
        sysApprovalRequestId: '', // 결재관련 결재요청코드

      },
      tabParam: {
        iimAccidentId: '',
        investigationFlag: '',
        investigationDate: '',
        investigationPlan: '',
        reportDate: '',
        occurrenceCause: '',
        accidentDamageHistory: '',
        emergencyMeasures: '',
        materialLossHistory: '',
        materialLossAmount: '',
        enviromentLeakInformation: '',
        enviromentImpactHistory: '',

        accidentInvestigationTeamModelList: [],
        deleteInvestigationTeamModelList: [],
        accidentVictimModelList: [],
        deleteAccidentVictimModelList: [],
      },
      splitter: 5,
      tab: 'processAccidentReceptionPlan',
      completeUrl: 'transactionConfig.sop.iim.accident.process.investigation.complete.url',
      completeType: 'PUT',
      isComplete2: false,
      isComplete1: false,
      insertUrl: '',
      deleteUrl: '',
      deleteAuthUrl: '',
      isInvest: false,
      isApproval: false,
      isDeleteAuth: false,
    };
  },
  watch: {
    'param.count'() {
      this.getStdInfo();
    }
  },
  computed: {
    approvalInfo() {
      return {
        sysApprovalRequestId: this.standardInfo.sysApprovalRequestId, // 결재요청번호
        /**
         * 결재상태코드
         * ASC0000001	결재중
         * ASC0000002	반려
         * ASC9999999	결재완료
         */
        approvalStatusCd: this.standardInfo.approvalStatusCd, 
        apprEditable: (this.isInvest && !this.disabled && this.tabParam.accidentStatusCd === 'ISPC000002' || this.tabParam.accidentStatusCd === 'ISPC000004') && !this.param.isApprovalPop, // 결재버튼 활성화 기준
        param: this.tabParam, // 결재 param
        approvalUrl: this.completeUrl, // 결재 url
        isApproval: this.isApproval, // 결재 submit
        approvalTypeCd: 'APTC000009', // 결재유형코드
        approvalParamValue: { // 결재상세화면 파라미터
          iimAccidentId: this.param.iimAccidentId,
          stepCd: this.param.stepCd,
          isApprContent: true,
          isApprovalPop: true,
        },
        approvalRequestName: '안전사고 ['+this.standardInfo.accidentName+']', // 결재요청명 (문서 title)
        approvalConnId: this.param.iimAccidentId, // 결재연결용 업무일련번호 (문서 key)
      }
    },
    tabHeight() {
      let numHeight = this.height ? Number(this.$_.replace(this.height, 'px', '')) : 600;
      if (numHeight <= 600) {
        numHeight = 836
      }
      numHeight = numHeight - 120
      return numHeight + 'px';
    },
    disabled() {
      return (this.param.stepCd === 'ISPC000005' // 종결
          || this.standardInfo.approvalStatusCd === 'ASC0000001') // 결재중
        && !this.param.updateBtnProps.data.flag
    },
    completeEditable() {
      return this.tabParam.investigationFlag === 'Y' // 조사대상
        && (this.tabParam.accidentStatusCd === 'ISPC000003' // 조사중
          || this.tabParam.accidentStatusCd === 'ISPC000002') // 사고등록
        && !this.disabled
    },
    tabItems() {
      return [
        { name: 'processAccidentReceptionPlan', icon: 'person_outline', label: '조사계획', component: () => import(`${'./processAccidentReceptionPlan.vue'}`), key: uid() },
        { name: 'processAccidentReceptionResult', icon: 'report', label: '조사결과', component: () => import(`${'./processAccidentReceptionResult.vue'}`), key: uid() },
        // { name: 'imprTab', icon: 'add_circle_outline', label: '개선관리', component: () => import(`${'@/pages/sop/ibm/imprTab.vue'}`) },
      ]
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.getUrl = selectConfig.sop.iim.accident.process.get.url;
      this.deleteUrl = transactionConfig.sop.iim.accident.process.delete.url;
      this.insertUrl = transactionConfig.sop.iim.accident.process.investigation.insert.url;
      this.completeUrl = transactionConfig.sop.iim.accident.process.investigation.complete.url;
      this.deleteAuthUrl = transactionConfig.sop.iim.accident.process.delete.auth.url;
      // code setting
      // list setting
      this.getStdInfo();
    },
    getStdInfo() {
      if (this.param.iimAccidentId) {
        this.$http.url = this.$format(this.getUrl, this.param.iimAccidentId);
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.standardInfo = _result.data;
          this.updateMode = true;
        },);
      }
    },
    transInfo(data) {
      this.tabParam = data;
    },
    /* eslint-disable no-unused-vars */ 
    remove() {
      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '삭제하시겠습니까?',
        // TODO : 필요시 추가하세요.
        type: 'info', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.$format(this.deleteUrl, this.tabParam.iimAccidentId);
          this.$http.type = 'DELETE';
          this.$http.request((_result) => {
            window.getApp.$emit('APP_REQUEST_SUCCESS');
            
            this.$emit('emitStep', {
              name: 'closePopup',
              param: {},
            })
          },);
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    deleteAuthAccident() {
      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '삭제하시겠습니까?\n(※ 연결된 [개선, 결재] 또한 같이 삭제됩니다.)',
        // TODO : 필요시 추가하세요.
        type: 'info', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.isDeleteAuth = !this.isDeleteAuth;
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    deleteAuthCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.$emit('emitStep', { name: 'closePopup' })
    },
    completeAccident() {
      this.completeUrl = this.completeUrl;
      this.completeType = 'PUT';
      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '조사완료 하시겠습니까?(저장과 함께 조사완료 됩니다.)',
        // TODO : 필요시 추가하세요.
        type: 'info', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          if (this.tabParam.investigationDate) {
            this.tabParam.investigationDate = this.tabParam.investigationDate.join();
          }
          if (this.tabParam.accidentVictimModelList) {
            this.$_.forEach(this.tabParam.accidentVictimModelList, _item => {
              if (_item.expectTreatmentDate)  _item.expectTreatmentDate = _item.expectTreatmentDate.join();
            })
          }
          this.tabParam.accidentStatusCd = 'ISPC000004'
          this.tabParam.regUserId = this.$store.getters.user.userId
          this.tabParam.chgUserId = this.$store.getters.user.userId

          this.isComplete1 = !this.isComplete1;
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    completeCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      if (this.tabParam.investigationDate) {
        this.tabParam.investigationDate = this.tabParam.investigationDate.split(',');
      }
      if (this.tabParam.accidentVictimModelList) {
        this.$_.forEach(this.tabParam.accidentVictimModelList, _item => {
          if (_item.expectTreatmentDate) {
            _item.expectTreatmentDate = _item.expectTreatmentDate.split(',')
          }
        })
      }
      // if (this.tabParam.accidentStatusCd) {
      //   this.$emit('emitStep', {
      //     name: 'currentStep',
      //     param: this.tabParam.accidentStatusCd 
      //   })
      // }
      this.getStdInfo();
    },
    saveDataAppr() {
      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '결재요청을 하시겠습니까?',
        // TODO : 필요시 추가하세요.
        type: 'info', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          if (this.tabParam.investigationDate) {
            this.tabParam.investigationDate = this.tabParam.investigationDate.join();
          }
          if (this.tabParam.accidentVictimModelList) {
            this.$_.forEach(this.tabParam.accidentVictimModelList, _item => {
              if (_item.expectTreatmentDate)  _item.expectTreatmentDate = _item.expectTreatmentDate.join();
            })
          }
          
          this.tabParam.accidentStatusCd = this.standardInfo.accidentStatusCd
          this.tabParam.regUserId = this.$store.getters.user.userId
          this.tabParam.chgUserId = this.$store.getters.user.userId
          
          let promises = [
            {
              func: this.approvalValue
            },
          ];
          this.$comm.orderedPromise(promises);
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    // [S] 결재관련 
    approvalCallback() { // 결재관련 결재요청버튼 callback
      this.$refs['appr-btn'].apprRequestPop();
      
      if (this.tabParam.investigationDate) {
        this.tabParam.investigationDate = this.tabParam.investigationDate.split(',');
      }
      if (this.tabParam.accidentVictimModelList) {
        this.$_.forEach(this.tabParam.accidentVictimModelList, _item => {
          if (_item.expectTreatmentDate) {
            _item.expectTreatmentDate = _item.expectTreatmentDate.split(',')
          }
        })
      }
      this.$emit('emitStep', {
        name: 'currentStep',
        param: this.tabParam.accidentStatusCd 
      })
    },
    approvalValue() {
      return new Promise(resolve => {
        this.isApproval = !this.isApproval
        resolve(true);
      });
      
    },
    currentStep() {
      if (this.tabParam.accidentStatusCd) {
        this.$emit('emitStep', {
          name: 'currentStep',
          param: this.tabParam.accidentStatusCd 
        })
      }
    },
    isInvestY(data) {
      this.isInvest = data;
    }
  }
};
</script>
